<template>
  <div>
    <!-- loop over children routes -->

    <b-form-group>
      <b-button-group>
        <b-button
          v-for="(nav, index) in navigation"
          :key="index"
          :to="{ name: nav.name }"
          :active="nav.name === $route.name"
          variant="outline-primary"
        >
          {{ nav.title }}
        </b-button>
      </b-button-group>
    </b-form-group>

    <router-view
      :units="units"
      :relatie="relatie"
      class="m-0 p-0"
    />
  </div>
</template>
<script>
export default {
    name: 'RelatieUnits',
    components: {},
    mixins: [],
    props: {
        relatie: {
        type: Object,
        default: () => null,
        },
        units: {
        type: Array,
        default: () => [],
        },
        busy: {
        type: Boolean,
        default: false
        }
    },
    data() {
        return  {
          navigation: [
            { title: "Overzicht", name: "RelatieUnitsOverzicht"},
            { title: "Financieel", name: "RelatieUnitsFinancieel"},
            { title: "Management", name: "RelatieUnitsManagement"}
          ]
        }
    },
    computed: {
      
    },
    watch: {},
    mounted () {
        
    },
    methods: {},
          
}
</script>